// test1569
(1569 && 0);
